import { render, staticRenderFns } from "./DormBigScreen.vue?vue&type=template&id=1ce880d0&scoped=true"
import script from "./DormBigScreen.vue?vue&type=script&lang=js"
export * from "./DormBigScreen.vue?vue&type=script&lang=js"
import style0 from "./DormBigScreen.vue?vue&type=style&index=0&id=1ce880d0&prod&scoped=true&lang=css"
import style1 from "./DormBigScreen.vue?vue&type=style&index=1&id=1ce880d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce880d0",
  null
  
)

export default component.exports